var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronBlackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3001 10.5091C12.3001 10.727 12.257 10.934 12.1706 11.1301C12.0915 11.3189 11.962 11.5005 11.7822 11.6748L3.48389 19.8786C3.20333 20.1546 2.86161 20.2926 2.45874 20.2926C2.19975 20.2926 1.95876 20.2272 1.73574 20.0965C1.51273 19.9657 1.33287 19.7914 1.19619 19.5736C1.0667 19.3557 1.00195 19.1087 1.00195 18.8327C1.00195 18.4333 1.15303 18.0773 1.45518 17.7651L8.84702 10.5091L1.45518 3.25318C1.15303 2.94812 1.00195 2.59222 1.00195 2.18549C1.00195 1.91675 1.0667 1.67343 1.19619 1.45554C1.33287 1.23038 1.51273 1.05243 1.73574 0.921692C1.95876 0.790955 2.19975 0.725586 2.45874 0.725586C2.86161 0.725586 3.20333 0.863587 3.48389 1.13959L11.7822 9.34335C11.9548 9.51766 12.0843 9.69925 12.1706 9.88809C12.257 10.0769 12.3001 10.2839 12.3001 10.5091Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBlackIcon);
export default __webpack_public_path__ + "static/media/chevron-black-icon.d2e0cb94dd860a2453f90816302912a4.svg";
export { ForwardRef as ReactComponent };